<template>
  <PageTemplate alternative>
    <Header mod="image" />
    <Banner :hiddenLogo="true" mod="image" />
    <SchedulesImage :colors="['#653145', '#DEBDCA', '#B6757E']" mod="image" />
    <Videos mod="image" color="#CA918F" />
    <Structure mod="image" />
    <Exams mod="image" color="#653145" />
    <Tips mod="image" />
    <Footer mod="image" logo="/img/image-footer.png" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Header from "../../shell/PagesHeader.vue";
import Banner from "../../templates/Banner.vue";
import Structure from "../../templates/Structure.vue";
import Videos from "../../templates/Videos.vue";
import Footer from "../../shell/PagesFooter.vue";
import SchedulesImage from "../../templates/SchedulesImage.vue";
import Exams from "../../templates/Exams.vue";
import Tips from "../../templates/Tips.vue";

export default {
  components: {
    PageTemplate,
    Header,
    Banner,
    Videos,
    Structure,
    Footer,
    SchedulesImage,
    Exams,
    Tips,
  },
};
</script>
